var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _circle, _path7, _rect, _rect2, _path8, _path9, _ellipse2, _circle2, _path10, _path11, _g, _path12, _circle3, _circle4, _path13, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirportTransfer2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 993.73,
    height: 422.322,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M608.038 422.322H386.63c-6.262 0-11.355-5.094-11.355-11.355V11.355C375.275 5.095 380.368 0 386.63 0h221.408c6.261 0 11.355 5.094 11.355 11.355v399.612c0 6.26-5.094 11.355-11.355 11.355ZM473.168 1.896c-53.018 0-95.997 42.98-95.997 95.997v313.074a9.459 9.459 0 0 0 9.459 9.459h221.408a9.459 9.459 0 0 0 9.459-9.46V11.357a9.459 9.459 0 0 0-9.459-9.46h-134.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M618.244 105.31c0 .676.759 1.22 1.704 1.22h292.523c.945 0 1.704-.544 1.704-1.22 0-.677-.759-1.221-1.704-1.221H619.948c-.945 0-1.704.544-1.704 1.22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "m380.339 279.582 2.895 76.719h-7.047v8.685h19.696v-8.685h-5.745l.41-76.72h-10.21z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M372.74 343.997a5.428 5.428 0 0 1 5.428 5.428v22.437a5.428 5.428 0 0 1-10.856 0v-22.437a5.428 5.428 0 0 1 5.427-5.428ZM400.242 343.997a5.428 5.428 0 0 1 5.429 5.428v22.437a5.428 5.428 0 0 1-10.856 0v-22.437a5.428 5.428 0 0 1 5.427-5.428Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7f6ff",
    d: "m444.392 231.781-111.46-5.066 17.37-7.961 97.709 1.447-3.619 11.58zM0 243.032l13.46-5.067 417.904 10.857 17.37-7.962-7.237 49.216-331.96-35.372L0 243.032z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "m107.48 271.62 2.058-16.916 331.959 35.372-1.81 24.97L107.48 271.62z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 330.761,
    cy: 285.01,
    fill: "#3f3d56",
    rx: 34.379,
    ry: 36.55
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 330.761,
    cy: 278.496,
    r: 25.332,
    fill: "#f7f6ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "m613.391 279.582-2.895 76.719h7.047v8.685h-19.695v-8.685h5.744l-.41-76.72h10.21z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.857,
    height: 33.293,
    x: 615.563,
    y: 343.997,
    fill: "#3f3d56",
    rx: 5.428,
    ry: 5.428
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10.857,
    height: 33.293,
    x: 588.06,
    y: 343.997,
    fill: "#3f3d56",
    rx: 5.428,
    ry: 5.428
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7f6ff",
    d: "m549.338 231.781 111.46-5.066-17.37-7.961-97.709 1.447 3.62 11.58zM509.444 216.188l-5.066-111.46-7.962 17.37 1.448 97.709 11.58-3.619zM993.73 243.032l-13.46-5.067-417.904 10.857-17.37-7.962 7.237 49.216 331.96-35.372 109.537-11.672z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "m886.251 271.62-2.059-16.916-331.959 35.372 1.81 24.97L886.25 271.62z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 662.969,
    cy: 285.01,
    fill: "#3f3d56",
    rx: 34.379,
    ry: 36.55
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 662.969,
    cy: 278.496,
    r: 25.332,
    fill: "#f7f6ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7f6ff",
    d: "m560.014 217.897-1.643 12.107-.854 65.168a65.854 65.854 0 0 1-1.752 14.287c-3.17 13.534-10.574 25.845-21.51 34.77-9.923 8.106-23.457 14.243-41.37 13.158-47.77-2.896-51.989-43.55-51.989-43.55l1.803-73.722.246-10.111 2.17-18.244s5.791-51.387 59.35-49.94c53.558 1.448 55.549 56.077 55.549 56.077Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "m456.696 200.903 10.857-17.37 13.751-4.343h47.045l11.58 4.343 10.51 17.37-19.195-8.685H477.4l-20.704 8.685z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3f3d56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m496.509 325.785 1.857 49.216h-4.52v5.572h12.634v-5.572h-3.685l.263-49.216h-6.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.634 367.108a3.482 3.482 0 0 1 3.482 3.482v14.394a3.482 3.482 0 1 1-6.965 0V370.59a3.482 3.482 0 0 1 3.483-3.482ZM509.277 367.108a3.482 3.482 0 0 1 3.482 3.482v14.394a3.482 3.482 0 1 1-6.965 0V370.59a3.482 3.482 0 0 1 3.483-3.482Z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7f6ff",
    d: "m473.037 204.523 9.999-36 1.927.535-10 36zM526.417 174.651l1.962-.385 7.204 36.662-1.962.385z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 734.416,
    cy: 103.754,
    r: 13,
    fill: "#f7f6ff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 374.602,
    cy: 146.306,
    r: 13,
    fill: "#f7f6ff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M80.244 390.31c0 .676.759 1.22 1.704 1.22h292.523c.945 0 1.704-.544 1.704-1.22 0-.677-.759-1.221-1.704-1.221H81.948c-.945 0-1.704.544-1.704 1.22Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 196.416,
    cy: 388.754,
    r: 13,
    fill: "#f7f6ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirportTransfer2);
export default __webpack_public_path__ + "static/media/airportTransfer2.d84c112ad1eb8ca4294c94a2f3dc7330.svg";
export { ForwardRef as ReactComponent };